<script>
import Base from "@/components/RequestDetails/EstateData.vue";

export default {
  name: "DefaultViewEstateData",
  extends: Base,
};
</script>

